// extracted by mini-css-extract-plugin
export default {"ourClients":"responsiveStyles_ourClients__eT10u","clients":"responsiveStyles_clients__dMdMN"};